export default __webpack_public_path__ + "static/media/icon-alert-success.c9097775.svg";